import { FormattedMessage } from "react-intl";

export default function HelpPage() {
  return (
    <section className="mx-auto flex w-full max-w-3xl flex-col gap-6 p-4 md:p-8">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight text-primary">
          <FormattedMessage id="help.title" />
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          <FormattedMessage id="help.description" />
        </p>
      </div>

      <div className="space-y-3 rounded-lg border bg-card p-5 text-sm shadow-sm">
        <p className="text-primary">
          <FormattedMessage id="help.primaryContact" />
        </p>
        <p>
          <FormattedMessage id="help.afterHours" />
        </p>
      </div>
    </section>
  );
}
